import { Navigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useUserRoles } from '@/hooks/useUserRoles';
import { toast } from 'sonner';
import brandLogoHorizontal from '@/assets/brand/nivela-logo-horizontal.png';

interface OwnerOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * Restringe rotas a Proprietário (super_admin) e DEVs (developer).
 * Demais usuários são redirecionados para /admin.
 */
export function OwnerOnlyRoute({ children }: OwnerOnlyRouteProps) {
  const { isSuperAdmin, isDeveloper, loading } = useUserRoles();
  const notifiedRef = useRef(false);

  const allowed = isSuperAdmin || isDeveloper;

  useEffect(() => {
    if (!loading && !allowed && !notifiedRef.current) {
      notifiedRef.current = true;
      toast.error('Acesso restrito ao Proprietário');
    }
  }, [loading, allowed]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <img src={brandLogoHorizontal} alt="Nível A" className="h-10 w-auto animate-pulse" />
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
